import React from 'react'
import ErrorMessage from '../UI/messages/ErrorMessage'
import SuccessMessage from '../../helpers/message/SuccessMessage'
import MySpiner from '../UI/spiner/MySpiner'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../helpers/response/ResponseHelper'
import { checkWorkPlaceNowAPI } from '../../api/workPlace/workPlaceAPI'
import WorkLinePlaceNotData from './WorkLinePlaceNotData'
import WorkLinePlaceForm from './form/WorkLinePlaceForm'
import WorkLinePlaceNow from './WorkLinePlaceNow'

// Загальний обʼєкт для складу, цехів та ін.
const WorkLinePlace = ({ department }) => {

    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkWorkPlaceNow()
    }, [])

    const checkWorkPlaceNow = () => {
        setError('')
        setLoading(true)
        setData(null)
        checkWorkPlaceNowAPI().then(data => {
            setData(data)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            // setErrorMain(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myBlock__content'>
        <p>
            Початок роботи за певним робочим столом. Відскануйте QR-код якщо готові почати виконувати робочі функції
        </p>

        <ErrorMessage
            error={error}
        />
        <SuccessMessage
            success={success}
        />

        {
            loading ?
                <MySpiner />
            : ''
        }

        {
            data && data.workPlacePresence ?
            // data && !data.workPlacePresence ?
                <WorkLinePlaceNow 
                    department={data.department}
                    workPlacePresence={data.workPlacePresence}
                />
            :
                <WorkLinePlaceNotData />
        }
    </div>
  )
}

export default WorkLinePlace